(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/api-board.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/api-board.js'); 
'use strict';

class Board {
  constructor(_ref) {
    let {
      boardModel,
      wagerModel
    } = _ref;
    this.boardModel = boardModel;
    this.wagerModel = wagerModel;
    const returnObj = {
      boardProps: this.boardProps,
      numSelections: this.numSelections,
      rowPriceMulti: this.rowPriceMulti,
      systemNum: this.systemNum,
      systemType: this.systemType
    };
    if (this.boardModel.has('numbersExtra')) {
      returnObj.boardData1 = this.boardModel.get('numbers').toArray();
      returnObj.boardData2 = this.boardModel.get('numbersExtra').toArray();
    } else {
      returnObj.boardData = this.boardModel.get('numbers').toArray();
    }
    if (svs.numbergames.productMapping.isLotto(this.wagerModel.get('productId'))) {
      returnObj.participation = this.wagerModel.get('rowPriceMulti') === 2 ? 'L1L2' : 'L1';
    } else if (svs.numbergames.productMapping.isKeno(this.wagerModel.get('productId'))) {
      const kString = this.boardModel.get('hasKungKeno') ? 'KK' : 'K';
      returnObj.participation = "".concat(kString).concat(this.boardModel.get('level'));
    } else {
      returnObj.participation = '0';
    }
    return returnObj;
  }
  get boardProps() {
    const manualNumbersLength = this.boardModel.get('numbers').getManualNumbersLength();
    const manualNumbersExtraLength = this.boardModel.has('numbersExtra') && this.boardModel.get('numbersExtra').getManualNumbersLength() || 0;
    const totalManualLength = manualNumbersLength + manualNumbersExtraLength;
    if (totalManualLength === 0) {
      return ['QUICKPICK'];
    } else if (totalManualLength === this.numSelections) {
      return [];
    }
    return ['PARTIALQP'];
  }
  get numSelections() {
    const {
      numbers,
      numbersExtra
    } = this.boardModel.getNumberListArrays();
    if (this.boardModel.has('numbersExtra')) {
      const {
        numbers,
        numbersExtra
      } = this.boardModel.getNumberListArrays();
      return "".concat(numbers.length, "+").concat(numbersExtra.length);
    }
    return numbers.length + (numbersExtra && numbersExtra.length || 0);
  }
  get rowPriceMulti() {
    if (svs.numbergames.productMapping.isKeno(this.wagerModel.get('productId'))) return this.wagerModel.get('rowPriceMulti');
    return 1;
  }
  get systemNum() {
    return 0;
  }
  get systemType() {
    if (this.wagerModel.get('isSystem')) {
      return ['MSYS'];
    }
    return ['SROW'];
  }
}
svs.numbergames.game_model.utils.API_Board = Board;
 })(window);